export const STOCK_LABELS = {
    in_stock: "Available",
    low_stock: "Low Stock",
    out_of_stock: "Out of Stock",
};

const STYLES = {
    in_stock: "bg-sage-soft text-sage-deep",
    low_stock: "bg-[#FDF6E3] text-[#B0891D]",
    out_of_stock: "bg-[#F2EFEA] text-neutral-500",
};

const OPS_STYLES = {
    low_stock: "bg-[#FBF3DC] text-[#9A7414] border border-[#EFDFAE]",
    out_of_stock: "bg-[#F6E2DE] text-[#9B3A2F] border border-[#E8C3BC]",
};

export const DRAFT_PILL = "bg-[#E9EEF3] text-[#4A5C70] border border-[#D3DCE6] whitespace-nowrap";

export default function StockPill({ status, className = "", testId, ops = false }) {
    // The "Available" badge is intentionally hidden — a normal in-stock state
    // needs no visual noise. Only Low Stock / Out of Stock remain.
    if (status === "in_stock") return null;
    const style = (ops && `${OPS_STYLES[status] || ""} whitespace-nowrap`) || STYLES[status] || STYLES.out_of_stock;
    return (
        <span
            data-testid={testId}
            className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-[11px] uppercase tracking-widest font-medium ${style} ${className}`}
        >
            {STOCK_LABELS[status] || "—"}
        </span>
    );
}
